import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import './footer.scss';
import { HashLink } from 'react-router-hash-link';
import emailjs from '@emailjs/browser';
import { Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
const Footer = () => {
    const currentYear = new Date().getFullYear();
    const formDesktop = useRef();
    const formMobile = useRef();
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const sendEmail = (e, formRef) => {
        e.preventDefault();

        emailjs.sendForm(
            'service_1jfnbjv',
            'template_ljvm8rs',
            formRef.current,
            '0bsaQ34kM5y5nImAo'
        ).then(() => {
            handleShow();
            formRef.current.reset();
        }).catch(() => {
            toast.error("Something went wrong! Please try again");
        });
    };
    return (
        <>
            <section className="main-footer ">
                <div className='custom-containerr1'>
                    <div className='top_footer'>
                        <div className='left_Side'>
                            <img src='\assets\footerlogo.png' className="logosize1" />
                            <h3>Elevating Security and IT Operations to New Heights.</h3>
                            <div className='iconnnnsmans'>
                                {/* <div className='icons_div'>
                                    <img src='\assets\y.svg' />
                                </div> */}
                                <a href='https://x.com/techsecure360' target='_blank' className='icons_div'>
                                    <img src='\assets\x.svg' />
                                </a>
                                 <a href='https://www.linkedin.com/company/techsecure360' target='_blank' className='icons_div'>
                                    <img src='\assets\linkedin.svg' />
                                </a>
                                {/* <div className='icons_div'>
                                    <img src='\assets\m.svg' />
                                </div>
                                <div className='icons_div'>
                                    <img src='\assets\n.svg' />
                                </div>
                                <div className='icons_div'>
                                    <img src='\assets\o.svg' />
                                </div>
                                <div className='icons_div'>
                                    <img src='\assets\p.svg' />
                                </div> */}
                            </div>
                        </div>
                        <div className='right_Side'>
                            <div>
                                <h4>Links</h4>
                                <HashLink to="/#whychooseus">Why Choose Us</HashLink>
                                <HashLink to="/#whatwedo">What We Do</HashLink>
                                <Link to="/coming-soon">Blog</Link>
                                {/* <HashLink to="/#ourwork">Our Work</HashLink> */}
                                <Link to="/coming-soon">FAQs</Link>

                            </div>
                            <div>
                                <h4>Connect</h4>
                                <a href='https://x.com/techsecure360' target='_blank'>X</a>
                                <Link to="/contactus">Contact Us</Link>
                                {/* <h5>Team</h5> */}
                            </div>
                            <div className='desktioooo'>
                                <h4>Newsletter</h4>
                                <h5>Subscribe to our Newsletter</h5>
                                <div className='input_Side_bar'>
                                    <form ref={formDesktop} onSubmit={(e) => sendEmail(e, formDesktop)}>
                                        <input
                                            type="email"
                                            name="email"
                                            required
                                            placeholder="Enter your email"
                                        />
                                        <button type="submit" className='arooooes' style={{ border: "none", background: "transparent" }}>
                                            <img src='\assets\arrow.svg' />
                                        </button>
                                        {/* {status === 'success' && <p className="text-green-600">Subscribed! Check your inbox. 📬</p>}
                                        {status === 'error' && <p className="text-red-600">Something went wrong. Try again.</p>} */}
                                    </form>

                                </div>
                            </div>
                        </div>
                        <div className='phonesidie'>
                            <h4>Newsletter</h4>
                            <h5>Subscribe to our Newsletter</h5>
                            <div className='input_Side_bar'>
                                <form ref={formMobile} onSubmit={(e) => sendEmail(e, formMobile)}>
                                    <input
                                        type="email"
                                        name="email"
                                        required
                                        placeholder="Enter your email"
                                    />
                                    <button type="submit" className='arooooes' style={{ border: "none", background: "transparent" }}>
                                        <img src='\assets\arrow.svg' />
                                    </button>
                                    {/* {status === 'success' && <p className="text-green-600">Subscribed! Check your inbox. 📬</p>}
                                        {status === 'error' && <p className="text-red-600">Something went wrong. Try again.</p>} */}
                                </form>

                            </div>
                        </div>
                    </div>

                </div>
                <div className='footer_bottom'>
                    <div className='custom-container1 new__side'>
                        <h6>©{currentYear} TechSecure360. All rights reserved.</h6>
                        <div className="policies">
                            <Link to="/coming-soon">Privacy Policy</Link>
                            <span>|</span>
                            <Link to="/coming-soon">Terms of Service</Link>
                        </div>
                    </div>

                </div>
            </section>



            <Modal className='modalsecure' show={show} onHide={handleClose} centered>
                <Modal.Header >
                    <Modal.Title>Thank you!  <svg onClick={handleClose} className="svcg" xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                        <path d="M18 6.5L6 18.5" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M6 6.5L18 18.5" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="textual_div">
                        <img src="\assets\emailicon.svg" className="imgggsize" />
                        <h3>Thank you for subscribing to our newsletter.
                        </h3>
                        <h4 className='text-center'>We're excited to keep you updated with the latest news, tips, and special offers.</h4>
                    </div>
                </Modal.Body>

            </Modal>


        </>
    )
}

export default Footer;
